// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets":"2ca0f50758f4f311cf27","shared":"7538d79ecce93fef0366"}[chunkId] + ".js";
};